export default class TrustindexCloseModule {
	constructor(widget)
	{
		this.widget = widget;

		if (sessionStorage.getItem('ti-widget-closed-'+this.widget.pid)) {
			this.widget.remove();
			this.widget.TrustindexWidget.destroy();
		}
	}

	click(event)
	{
		if (event.target.matches('.disable-widget, .ti-close-button')) {
			event.preventDefault();

			if (!Trustindex.isAdminUrl() && !Trustindex.isWordpressAdminUrl()) {
				sessionStorage.setItem('ti-widget-closed-'+this.widget.pid, true);

				this.widget.remove();
				this.widget.TrustindexWidget.destroy();
			}
		}
	}
};